import { projectsSignal } from '../../state/ai.store';
import { isLoadingProjectsSignal } from '../../state/contacts.store';

export function ProjectsTab() {
  const projects = projectsSignal.value;
  const isLoadingProjects = isLoadingProjectsSignal.value;

  if (isLoadingProjects) {
    return (
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3 animate-pulse">
        <div class="h-16 bg-slate-900/80 border border-slate-800 rounded-xl"></div>
        <div class="h-16 bg-slate-900/80 border border-slate-800 rounded-xl"></div>
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div class="p-4 text-center text-xs text-slate-500 font-mono bg-slate-950/40 rounded-xl border border-slate-800">
        Nenhum tópico de projeto identificado ainda.
      </div>
    );
  }

  return (
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
      {projects.map(p => (
        <div key={p.id} class="p-3.5 bg-slate-900/80 border border-slate-800 rounded-xl space-y-1">
          <div class="flex items-center justify-between">
            <h4 class="text-xs font-bold text-slate-100">{p.name}</h4>
            <span class="px-2 py-0.5 rounded text-[9px] font-bold bg-cyan-500/20 text-cyan-300 border border-cyan-400/30 uppercase">
              {p.status}
            </span>
          </div>
          {p.description && (
            <p class="text-[11px] text-slate-400 leading-relaxed">{p.description}</p>
          )}
        </div>
      ))}
    </div>
  );
}
